import React from 'react'

import { fetchInterview } from 'api/interview'

// NOTE: hook that gathers all the data fetching handlers
// and exposes them for local hooks
export const useQueries = () => {
  const handleFetchInterview = React.useCallback(
    async ({ uuid }) => await fetchInterview({ uuid }),
    [],
  )

  return { handleFetchInterview }
}
